module.exports = __webpack_public_path__ + "img/00045.4c31d94a.webp";